export enum ContractName {
  RR = "rr.century",
  M = "m.century",
  Toc = "toc.century",
  S = "s.century",
  SimpleAssets = "simpleassets",
  AtomicAssets = "atomicassets",
}
